var render = function render(_c,_vm){return _c('div',{staticClass:"vx-col w-full mb-1 mt-2"},[_vm._m(0),_c('vs-divider')],1)
}
var staticRenderFns = [function (_c,_vm){return _c('p',[_c('strong',[_vm._v("Datos de la dirección de su empleo:")])])
}]

export { render, staticRenderFns }